import { SortOrderEnum } from '@shared/enums';
import { TableColumn, TextValue } from '@shared/interfaces';
import { groupMemberRoleNames } from '../consts/group-member-role.const';
import { GroupMemberRole } from '../enums';
import { GroupMembersTableColumnEnum, groupMembersTableColumnText } from '../enums/group-member-table-column.enum';

export function initializeGroupMemberRolesList(): TextValue[] {
    return [
        { text: groupMemberRoleNames[GroupMemberRole.ALL], value: GroupMemberRole.ALL },
        { text: groupMemberRoleNames[GroupMemberRole.RESEARCHER], value: GroupMemberRole.RESEARCHER },
        { text: groupMemberRoleNames[GroupMemberRole.GROUP_MANAGER], value: GroupMemberRole.GROUP_MANAGER },
        { text: groupMemberRoleNames[GroupMemberRole.PI], value: GroupMemberRole.PI },
    ];
}

export function initializeGroupMembersTableColumns(isActiveGroup: boolean): TableColumn<GroupMembersTableColumnEnum>[] {
    return [
        {
            field: GroupMembersTableColumnEnum.MEMBERS,
            name: groupMembersTableColumnText[GroupMembersTableColumnEnum.MEMBERS],
            centered: false,
            width: '25%',
            minWidth: '100px',
            maxWidth: '30vw',
            isVisible: true,
            isMainColumn: true,
            isSortingActive: false,
            isSortingEnabled: false,
            sortOrder: SortOrderEnum.ASC,
            sortPriority: null,
            numericalSort: false,
            widthRatio: 2,
        },
        {
            field: GroupMembersTableColumnEnum.EMAIL,
            name: groupMembersTableColumnText[GroupMembersTableColumnEnum.EMAIL],
            centered: false,
            width: '25%',
            minWidth: '100px',
            maxWidth: '30vw',
            isVisible: true,
            isMainColumn: false,
            isSortingActive: false,
            isSortingEnabled: false,
            sortOrder: SortOrderEnum.ASC,
            sortPriority: null,
            numericalSort: false,
            widthRatio: 2,
        },
        {
            field: GroupMembersTableColumnEnum.ROLE,
            name: groupMembersTableColumnText[GroupMembersTableColumnEnum.ROLE],
            centered: false,
            width: '25%',
            minWidth: '100px',
            maxWidth: '30vw',
            isVisible: true,
            isMainColumn: false,
            isSortingActive: false,
            isSortingEnabled: false,
            sortOrder: SortOrderEnum.ASC,
            sortPriority: null,
            numericalSort: false,
            widthRatio: 2,
        },
        {
            field: GroupMembersTableColumnEnum.INTERNAL_EXTERNAL,
            name: groupMembersTableColumnText[GroupMembersTableColumnEnum.INTERNAL_EXTERNAL],
            centered: true,
            width: '20%',
            minWidth: '100px',
            maxWidth: '30vw',
            isVisible: true,
            isMainColumn: false,
            isSortingActive: false,
            isSortingEnabled: false,
            sortOrder: SortOrderEnum.ASC,
            sortPriority: null,
            numericalSort: false,
            widthRatio: 2,
        },
        {
            field: GroupMembersTableColumnEnum.ACTIONS,
            name: groupMembersTableColumnText[GroupMembersTableColumnEnum.ACTIONS],
            centered: true,
            width: '5%',
            minWidth: '70px',
            maxWidth: '10vw',
            isVisible: isActiveGroup,
            isMainColumn: false,
            isSortingActive: false,
            isSortingEnabled: false,
            sortOrder: SortOrderEnum.ASC,
            sortPriority: null,
            numericalSort: false,
            widthRatio: 1,
        },
    ];
}
